import { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { ButtonProps, CircularProgress } from '@material-ui/core';

import useStyles from './styles';
import useStore from '@hooks/useStore';
import OysterButton from '@components/common/Button';
import { privacyLink, termsLink } from '@configs/variables';

export interface IPayButtonProps extends ButtonProps {
  loading?: boolean;
  hideDisclaimer?: boolean;
  customDisclaimer?: ReactNode;
  label?: string;
  isSubscription?: boolean;
}

const PayButton: FC<IPayButtonProps> = ({
  loading = false,
  hideDisclaimer = false,
  label,
  children,
  isSubscription = false,
  customDisclaimer,
  ...props
}) => {
  const {
    links: {
      coBrandingConfig: { primaryColor, secondaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor, secondaryColor });

  const ButtonContent = () => {
    if (loading) {
      return (
        <CircularProgress className={css.progress} data-testid="pay-button-progress" size={24} />
      );
    }
    return <>{label ? label : children}</>;
  };

  return (
    <>
      {!hideDisclaimer && (
        <div data-testid="pay-button-disclaimer" className={css.disclaimer}>
          {customDisclaimer ? (
            customDisclaimer
          ) : (
            <Trans
              i18nKey={
                !isSubscription
                  ? 'checkoutScreen.payment.methods.disclaimer'
                  : 'checkoutScreen.payment.methods.disclaimerSubscription'
              }
            >
              <strong />
              <a href={termsLink} target="_blank" rel="noreferrer noopener" />
              <a href={privacyLink} target="_blank" rel="noreferrer noopener" />
            </Trans>
          )}
        </div>
      )}
      <OysterButton {...props} fullWidth data-testid="pay-button" className={css.submitButton}>
        <ButtonContent />
      </OysterButton>
    </>
  );
};

export default PayButton;
